<template>
    <v-content style="height: 100%;" class="px-0 mx-auto">
        <v-row style="max-width: 600px; margin: 0 auto;" >
            <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
                <v-row justify="center" align="center">
                    <v-col calign-self="center" cols="auto">
                        <v-row justify="center" >
                            <v-progress-circular
                            :size="70"
                            :width="7"
                            :color="$store.state.colors.primary"
                            indeterminate
                            ></v-progress-circular>                        
                        </v-row> 
                    </v-col>
                </v-row>
            </v-col>   
            <v-col v-else id="base" md="12" style="height: 100%;" class="mt-0 pt-0" >
                <v-row align="center" style="height: 35px; background-color: #4d4d4d; color: white; position: relative" class="pt-0">
                    <v-img max-width="24px" src="@/assets/resources/menu/icon_location_white.png"></v-img>
                    <span v-if="solo_sucursal()" class="RestoRegular" style="font-size: 18px">Entregar aquí</span>   
                    <span v-else class="pl-3 RestoRegular" style="font-size: 16px"><a @click="$router.push({ name: 'select_delivery'})" class="a" style="color: white"> Cambiar Sucursal </a></span>   
                    <span v-if="!solo_sucursal()" class="RestoRegular pr-2" style="font-size: 16px; position: absolute; right: 0px; margin: auto; color: white;">  {{sucData.sucursal_corto}} </span>
                </v-row>
                <v-row  align="center" justify="end" style="height: auto; background-color: #e6e6e6; color: #4d4d4d" class="py-0 my-0">
                    <v-col style="position: relative;">
                        <v-row align="center" justify="center" style="min-height: 35px; color: #4d4d4d;" class="RestoRegular">
                            <select @change="temp_event=$event; checkS()" @focus="saveCurrentValue($event)" id="country" name="country" style="z-index: 1">
                                <option value="sucursal" > Recoger en sucursal </option>
                                <option :selected="selectedAddress[index]" v-for="(address, index) in addresses" :key="index" :value="address.id_direccion">{{address.calle}}, {{address.colonia}}</option>
                            </select>
                        </v-row>
                        <v-row align="start" justify="end" style=" position: absolute; top: 18px; right: 30px; z-index: 0" >
                            <v-img max-width="20px" src="@/assets/resources/menu/icon_arrow_unfold.png"></v-img>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="sticky pl-2" align="center" style="height: 60px; background-color: #E6E6E6; overflow-x: auto; white-space: nowrap; font-size: 0; ">
                    <div style="display: inline-block;">
                        <v-btn small @click="scrollTo(category.categoria)" v-for="(category, index) in newmenu" :key="index" class="ml-2" outlined rounded>
                            {{category.categoria}}
                        </v-btn>
                    </div>
                </v-row>


                <!-- Menu -->
                <v-row v-show="search_dish(category.platillos,index).length!=0" v-for="(category, index) in newmenu" :key="index" :id="category.categoria" style="border-top: .1px solid #E8E8E8;">
                    <v-col class="pb-0 mb-0" >
                        <v-row justify="start" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 25px;" :style="{ 'color': $store.state.colors.primary }">
                            {{category.categoria}}
                        </v-row>
                        <v-row justify="start" class="pl-2 RestoLight py-0 my-0" style="font-size: 15px;text-align: center; ">
                            {{category.descripcion}}
                        </v-row>
                        <v-row justify="center" align="start">
                            <v-col  class="mb-0 pb-0">
                                <v-row v-for="(item, index2) in search_dish(category.platillos,index)" :key="index2" justify="center" style="border-top: .1px solid #E8E8E8;">
                                    <v-col cols="auto" sm="auto" md="auto" lg="auto" xl="auto" align-self="start" >
                                        <v-img @click="sendOption(item.id_categoria)" height="100px" max-width="100px" :src="item.imagen == null ? require('@/assets/resources/yoomi/yoomy-screen.png'): item.imagen" >
                                        </v-img>
                                    </v-col>
                                    <v-col align-self="start">
                                        <v-row style="font-size: 16px;" class="RestoBold" align="center">
                                            {{item.platillo}}
                                        </v-row>
                                        <v-row style="font-size: 12px; " align="center">
                                            {{item.descripcion}}
                                        </v-row>
                                        <v-row class="RestoBold">
                                            <v-col align-self="center">
                                                <v-row justify="start">
                                                    ${{item.precio}}
                                                </v-row>
                                            </v-col>
                                            <v-col align-self="center">
                                                <v-row justify="end" class="pr-2">
                                                    <v-btn @click="sendOption(item)" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                                                        Agregar
                                                    </v-btn>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog"
            max-width="290"
            persistent
        >
            <v-card>
                <v-col>
                    <v-row class="RestoBold pt-4"  style="width: 90%; margin: 0 auto; font-size: 18px; text-align: center">
                        Si decides cambiar de dirección tu pedido actual se perderá <br>¿Deseas continuar?    
                    </v-row>
                </v-col>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="notNewAddress()" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="newAddress()" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="servicio"
            max-width="290"
            persistent
            overlay-opacity="0.5"
        >
            <v-card>
                <v-col>
                    <v-row class="RestoBold pt-4 pb-4"  style="width: 90%; margin: 0 auto; font-size: 16px; text-align: center">
                        Por el momento la sucursal no está en servicio, intenta en otro momento    
                    </v-row>
                    <v-row justify="center" class="RestoBold pt-0 pb-4"  style="width: 90%; margin: 0 auto; font-size: 18px; text-align: center">
                        <v-btn @click="exit" :color="$store.state.colors.primary" width="100%" style="color: white" class="buttonLower">
                            Salir
                        </v-btn>
                    </v-row>
                </v-col>
            </v-card>
        </v-dialog>
    </v-content>
</template>

<script>
  export default {
    data () {
      return {
            sucData: JSON.parse(localStorage.getItem("sucursalData")),
            servicio: false,
            orders: null,
            sizeP: null,
            selectedAddress: [],
            sizeF: null,
            image: "burritos",
            activeColor: '#E5DFDE',
            addresses: null,
            newmenu: [],
            platillos_tamanio: [],
            platillos_tamanio_temp: [],
            trampa: true,
            dialog: false,
            address:JSON.parse(localStorage.getItem("addressUser")),
            current_value: null,
            temp_event: null,
            validateLoad:true,
      }
    },
    methods: {
        checkS() {            
            if(document.getElementById('country').value == "sucursal")
            {
                this.$router.push({ name: 'select_delivery', params: {selector: true}});

            }
            else
                this.dialog=true
        },
        solo_sucursal() {
            if(localStorage.getItem('solo_sucursal') == 'Y')
                return false;
            else    
                return true;
        },
        exit() {
          this.$store.state.lista_platillos = []; 
          this.$store.dispatch('initilizePedido')

          localStorage.removeItem('original_id_sucursal'); 
          localStorage.removeItem('sucursalData'); 
          localStorage.removeItem('comentarios'); 
          localStorage.removeItem('metodo_envio'); 
          localStorage.removeItem('Servicio'); 
          localStorage.removeItem('userCards'); 
          localStorage.removeItem('propina'); 
          localStorage.removeItem('propinasBandera'); 
          localStorage.removeItem('formas_aceptadas'); 
          this.$store.state.validationDelivery=false;
          localStorage.removeItem('token'); 
          this.$store.state.token = null; 
          this.$store.state.logo = false;
          localStorage.removeItem('id_cliente'); 
          this.$store.state.id_cliente = null; 
          localStorage.removeItem('id_sucursal'); 
          this.$store.state.id_sucursal = null; 
          localStorage.removeItem('nombre_cliente'); 
          localStorage.removeItem('addressUser');
          this.$store.state.nombre_cliente = null; 
          this.$router.push({ name: 'logo'});
          localStorage.removeItem('tokenDM'); 
          this.$store.state.tokenDM = null; 
        },
        saveCurrentValue(event){
            this.current_value = event.target.selectedIndex
        },
        search_dish(platillos,index){
            var cosa = platillos.filter(m => {
                return m.platillo.toLowerCase().includes(this.$store.state.footer_search.toLowerCase());
            });
            this.platillos_tamanio[index]=cosa.length;
            return cosa;
        },
        sendOption(value){
            var v = value.id_platillo
            this.$router.push({ name: 'details', params: {id_platillo: v}});

        },
        scrollTo(id) {
            // console.log(id);
            // var element = document.getElementById(id);
            // var container = document.getElementById('base');
            // var go = $(element)
            
            // $(document).ready(function() {
            //     console.log($('#Comida').offset().top);
            //     $('#base').animate({
            //         scrollTop: 0
            //     });
            // });
            // document.getElementById(id).scrollIntoView(true);
            // document.getElementById(id).scrollIntoView(true);
            // document.getElementById(id).scrollBy(0, -50);
            
            // document.getElementById(id).scrollTop -= 155;
            document.getElementById(id).scrollIntoView({behavior: "instant", block: "start", inline: "nearest", alignTo: false});
            // document.getElementById("base").scrollTop -= 50;
        },
        newAddress()
        {
            for(var i=0;i<this.addresses.length;i++)
            {
                if(this.addresses[i].id_direccion==this.temp_event.target.value)
                {
                    // console.log("Changing Address");
                    this.$store.state.lista_platillos = []; 
                    localStorage.setItem('platillos', JSON.stringify([]));
                    localStorage.setItem("id_sucursal", this.addresses[i].id_sucursal);
                    localStorage.setItem("original_id_sucursal", this.addresses[i].id_sucursal);
                    localStorage.setItem("addressUser",JSON.stringify(this.addresses[i]));
                    if(this.addresses[i].servicio != "activo")
                        localStorage.setItem("Servicio", "true")
                    else
                        localStorage.setItem("Servicio", "false")
                    localStorage.setItem("propinasBandera", this.addresses[i].propinas);
                    localStorage.setItem("formas_aceptadas", this.addresses[i].formas_aceptadas);
                    localStorage.setItem("minimo_pedido", this.addresses[i].minimo_pedido);
                    var sucursalData = {calle: this.addresses[i].calle_suc, ciudad: this.addresses[i].ciudad_suc, sucursal: this.addresses[i].sucursal, telefono: this.addresses[i].telefono_suc, num_exterior: this.addresses[i].num_exterior_suc}
                    console.log(sucursalData)
                    localStorage.setItem("solo_sucursal", "N");
                    localStorage.setItem("sucursalData", JSON.stringify(sucursalData));
                    i=this.addresses.length;
                    location.reload();
                }
            }
            this.dialog = false;
            // console.log(JSON.parse(localStorage.getItem("addressUser")));
        },
        notNewAddress(){
            document.getElementById("country").selectedIndex = this.current_value;
            this.dialog = false;
        },
    },
    watch: {
        platillos_tamanio: function(val) {
                this.platillos_tamanio_temp=val;
                // console.log("TEMPORAL: ",this.platillos_tamanio_temp);
            },
        trampa: function(){
            // console.log("Hola");
            this.platillos_tamanio_temp=this.platillos_tamanio;
        }
    },
    created() {
        if(localStorage.getItem("Servicio") == "true")
            this.servicio = true;
    },
    beforeCreate() {
        if(localStorage.getItem("id_sucursal") == "0")
            this.$router.push({ name: 'select_delivery'});
        else 
        {
            this.$store.dispatch("GET", {url: 'notificaciones/' + localStorage.getItem("id_cliente"), headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                //   console.log(`%cRESPONSE`, 'color: green; font-weight: bold;', response);
                this.orders = response.data;
                this.$store.state.notifications_amount = this.orders.length;
            })
            .catch(error => {
                console.log("Error: " + error);
            });
            
            this.$store.state.validationDelivery=false;
            this.$store.state.hideFooter = true;
            this.$store.dispatch("GET", {url: '/cat_plat/' + localStorage.getItem("id_sucursal"), headers: {Authorization: localStorage.getItem("token")}})
                .then(response => {
                    console.log(`%cRESPONSE`, 'color: green; font-weight: bold;', response);
                    this.newmenu = response.data.categorias;
                    this.platillos_tamanio = [];
                    for(var t=0; t<this.newmenu.length; t++){
                        this.platillos_tamanio.push(this.newmenu[t].platillos.length);
                    }
                    // console.log("TAMAÑO: ",this.platillos_tamanio);
                    this.addresses = response.data.direcciones;
                    
                    if(localStorage.getItem('original_id_sucursal') != '0')
                    {
                        if(localStorage.getItem("addressUser")===null || !localStorage.getItem("addressUser"))
                        {
                            if( (this.addresses != null || this.addresses) && localStorage.getItem("solo_sucursal") != 'Y' )
                            { 
                            //    console.log("NO HAY DIRECCION");
                                this.selectedAddress = new Array(this.addresses.length).fill(false);
                                this.selectedAddress[0] = true;
                                // console.log("Adding Address");
                                localStorage.setItem("id_sucursal", this.addresses[0].id_sucursal);
                                localStorage.setItem("addressUser",JSON.stringify(this.addresses[0]));
                                if(response.data.direcciones[0].servicio != "activo")
                                {
                                    localStorage.setItem("Servicio", "true")
                                    this.servicio = true;
                                }
                                    
                                localStorage.setItem("propinasBandera", response.data.direcciones[0].propinas);
                                localStorage.setItem("formas_aceptadas", response.data.direcciones[0].formas_aceptadas);
                                localStorage.setItem("minimo_pedido", response.data.direcciones[0].minimo_pedido);
                                var sucursalData = {calle: response.data.direcciones[0].calle_suc, ciudad: response.data.direcciones[0].ciudad_suc, sucursal: response.data.direcciones[0].sucursal, telefono: response.data.direcciones[0].telefono_suc, num_exterior: response.data.direcciones[0].num_exterior_suc}
                                console.log(sucursalData)
                                localStorage.setItem("sucursalData", JSON.stringify(sucursalData));
                            }
                        }
                        else {
                            if((this.addresses != null || this.addresses) && localStorage.getItem("solo_sucursal") != 'Y' )
                            { 
                                    var addr = JSON.parse(localStorage.getItem("addressUser"));

                                    var index = this.addresses.map(function(e) {
                                        return e.id_direccion;
                                    }).indexOf(addr.id_direccion);
                                    // console.log("Address Index", index);
                                    this.selectedAddress = new Array(this.addresses.length).fill(false);
                                    this.selectedAddress[index] = true;
                            }
                        }
                    }
                    this.validateLoad=false;
                })// eslint-disable-next-line
                .catch(error => {
                    console.log("Error: " + error);
                    this.$router.push({ name: 'verification'});
                    // console.log("EXIT");
                    localStorage.removeItem('original_id_sucursal'); 
                    localStorage.removeItem('Servicio'); 
                    localStorage.removeItem('sucursalData'); 
                    localStorage.removeItem('comentarios'); 
                    localStorage.removeItem('propina'); 
                    localStorage.removeItem('propinasBandera'); 
                    localStorage.removeItem('formas_aceptadas'); 
                    this.$store.state.validationDelivery=false;
                    localStorage.removeItem('token'); 
                    this.$store.state.token = null; 
                    this.$store.state.logo = false;
                    localStorage.removeItem('id_cliente'); 
                    this.$store.state.id_cliente = null; 
                    localStorage.removeItem('id_sucursal'); 
                    this.$store.state.id_sucursal = null; 
                    localStorage.removeItem('nombre_cliente'); 
                    this.$store.state.nombre_cliente = null; 
                    localStorage.removeItem('addressUser');
                    this.$router.push({ name: 'logo'});
                    localStorage.removeItem('tokenDM'); 
                    this.$store.state.tokenDM = null;
                });
        }
    },
    beforeRouteLeave (to, from, next) {
        this.$store.state.footer_search = "";
        next();
    }
  }
</script>

<style scoped>

    .cards {
        background-color: #EEEEEE ;
        color: #BFBBBA ;
    }
    .cards:focus, .cards:hover {
        background-color: #A8A8A8;
        color: white;
    }

    div.sticky {
        position: -webkit-sticky;
        position: sticky;
        top: -1px;
        z-index: 1;
    }

    select {
        width: 93%;
        padding: 5px 20px;
        border: none;
        border-radius: 4px;
        background-color: transparent;
    }
    .a:hover 
    { 
        background-color: transparent;
    } 
    
</style>